// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/app-" + chunkId + "." + {"2807":"b9156935","4024":"3d28d785","6207":"6c5e1215","6916":"c7286d0c"}[chunkId] + ".chunk.css";
};